import { createApp } from 'vue';

import App from 'src/App.vue';
import router from 'src/router';

export const app = createApp(App);

app.use(router);

import { initQuasar } from 'src/boot/quasar';
initQuasar(app);

import { initPrimevue } from 'src/boot/primevue';
initPrimevue(app);

import { createPinia } from 'pinia';
app.use(createPinia());

//SENTRY
import { initSentry } from 'src/boot/sentry';
initSentry(app, router);

//I18N
import { initI18n } from 'src/boot/i18n';
initI18n(app);

// new Design system material icons native support
import 'src/css/material-icons.css';
import 'src/css/app.scss';

import 'animate.css';

import 'src/css/oldQuasarIcons/materialIcons.css'; // Material Icons CSS

// init component library
import { initComponentLibrary } from 'src/boot/componentLibrary';
initComponentLibrary(app);

import 'src/css/tailwind.css';

app.mount('#app');
